export const work_experience = [
    {
        company_name:'Quantiphi Analytics',
        company_location:'Mumbai, Maharashtra',
        job_title:'Software Developer',
        job_skills:' Angular, Django, Flask, MySQL, GCP, AWS, Javascript',
        job_duration:'August, 2020 - Present',
        job_description:[
            {
                project_name:'Data Sharing Platform',
                project_description:'Developed platform having data registration, data access request (entire dataset/tables), data deletion (entire/partial), access revoke, dataset table addition/change, application registration, alert notifications, approval/rejection functionalities across 3 user types (consumer/owner/admin).',
                key_skills:'Angular, Django, Javascript, GCP, Datastore, Big query, Cloud storage'
            },
            {
                project_name:'Customer Data Platform',
                project_description:'Developed a product that collects & unifies first party customer data from multiple sources to build a single, coherent, complete view of each customer.',
                key_skills:'Angular, JavaScript, NodeJS, Rest API, SQL, Big query'
            },
            {
                project_name:'Data Pipeline for Recommendation Engine',
                project_description:'Transformed Big Query data to Recommendation AI’s standard schema to feed the model and based on that got recommendation results.',
                key_skills:'Flask, MySQL, GCP, Cloud SQL'
            }
        ],
    },
    {
        company_name:'BMC Software India',
        company_location:'Pune, Maharashtra',
        job_title:'Project Intern',
        job_skills:'Angular, Spring Boot, PostgreSQL, BMC Adapt, Git',
        job_duration:'September 2019 - May 2020',
        job_description:[
            {
                project_name:'Automated Parcel Management System',
                project_description:'Developed a real time application for BMC employees to efficiently manage their parcels. Created web and mobile application for BMC employees and security guards to increase the efficiency of the process and automate the parcel management system.',
                key_skills:'Angular, Spring Boot, PostgreSQL, BMC Adapt, Git'
            }
        ]
        },
    {
        company_name:'Way For Life',
        company_location:'Virtual',
        job_title:'Android Development Intern',
        job_skills:'Java, Android Studio, Firebase',
        job_duration:'December 2018 - Feburary 2019',
        job_description:[
            {
                project_name:'Android Application',
                project_description:'Developed an android application for the company.',
                key_skills:'Java, Android Studio, Firebase'
            }
        ]
    }
]